import { render, staticRenderFns } from "./AppTextSearchOrInput.vue?vue&type=template&id=87d0d6d8&scoped=true&"
import script from "./AppTextSearchOrInput.vue?vue&type=script&lang=ts&"
export * from "./AppTextSearchOrInput.vue?vue&type=script&lang=ts&"
import style0 from "./AppTextSearchOrInput.vue?vue&type=style&index=0&id=87d0d6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d0d6d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VTextField,VTooltip})
